module.exports = __webpack_public_path__ + "assets/01.a5e3e608.pdf";